import { useState, useEffect } from "react";
import Store from "../store/Store";

const STORAGE_KEY_OPEN_BLOCKS = "openBlocks";
// const STORAGE_KEY_NEW_NOTE = "newNoteVisible";

const useNote = () => {

    let {user} = Store.getState();

    const [openBlocks, setOpenBlocks] = useState(() => {
        const storedData = localStorage.getItem(STORAGE_KEY_OPEN_BLOCKS);
        return storedData ? JSON.parse(storedData) : {};
    });
    
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY_OPEN_BLOCKS, JSON.stringify(openBlocks));
    }, [openBlocks]);

    // Megjegyzés blokk kinyitása/zárása
    const toggleBlockState = (blockName) => {
        setOpenBlocks((prev) => {
            const newState = { ...prev, [blockName]: !prev[blockName] };
            localStorage.setItem(STORAGE_KEY_OPEN_BLOCKS, JSON.stringify(newState));
            return newState;
        });
    };

    // const [newNoteVisible, setNewNoteVisible] = useState(() => {
    //     const storedData = localStorage.getItem(STORAGE_KEY_NEW_NOTE);
    //     return storedData ? JSON.parse(storedData) : {};
    // });

    // useEffect(() => {
    //     localStorage.setItem(STORAGE_KEY_NEW_NOTE, JSON.stringify(newNoteVisible));
    // }, [newNoteVisible]);

    // Új megjegyzés írási mező megjelenítése/elrejtése
    // const toggleNewNoteState = (blockName) => {
    //     setNewNoteVisible((prev) => {
    //         const newState = { ...prev, [blockName]: !prev[blockName] };
    //         localStorage.setItem(STORAGE_KEY_NEW_NOTE, JSON.stringify(newState));
    //         return newState;
    //     });
    // };


    const [newNoteVisible, setNewNoteVisible] = useState({});
    // Új megjegyzés írási mező megjelenítése/elrejtése
    const toggleNewNoteState = (blockName) => {
        setNewNoteVisible((prev) => ({
            ...prev,
            [blockName]: !prev[blockName]
        }));
    };

    const isOwnNote = (note)=>{
        if(note.user_id === user.id){
            return true;
        }else{
            return false;
        }
    }

    return {
        openBlocks,
        toggleBlockState,
        newNoteVisible,
        toggleNewNoteState,
        isOwnNote,
    };
};

export default useNote;

